module.exports = __webpack_public_path__ + "static/media/users-active-icon.7248d5c1.svg";